import { render, staticRenderFns } from "./BaseInputDecimalNumber.vue?vue&type=template&id=a7640822&scoped=true&"
import script from "./BaseInputDecimalNumber.vue?vue&type=script&lang=js&"
export * from "./BaseInputDecimalNumber.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDecimalNumber.vue?vue&type=style&index=0&id=a7640822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7640822",
  null
  
)

export default component.exports